<template>
	<section>
		<div class="split">
			<div class="left">
				<slot name="left" />
			</div>
			<div class="right">
				<slot name="right" />
			</div>
		</div>
	</section>
</template>

<style lang="css" scoped>
section div.split
{
	display: flex;
	align-items: center;
	max-width: 1160px;
	height: 100%;
	margin: 0 auto;
	padding: 4rem 2rem;
	box-sizing: border-box;
	gap: 2rem;
}

section div.split > div
{
	position: relative;
}

section div.split > div.left,
section div.split > div.right
{
	flex: 1;
}

section div.split > div:has(img),
section div.split > div:has(picture),
section div.split > div:has(video)
{
	text-align: center;
}

section :deep(img),
section :deep(picture),
section :deep(video)
{
	max-width: 500px;
	border-radius: .7rem;
	box-shadow: rgb(var(--black)) 0px 20px 30px -10px;
	height: auto;
}

@media screen and (max-width: 1050px)
{
	section :deep(img),
	section :deep(video)
	{
		width: 400px;
	}
}

@media screen and (max-width: 900px)
{
	section div.split
	{
		align-items: normal;
		flex-direction: column;
		max-width: none;
		margin: 0;
		padding: 0;
	}

	section div.split > div:has(img),
	section div.split > div:has(picture),
	section div.split > div:has(video)
	{
		flex: 1 50vh !important;
		order: 2;
	}

	section div.split > div:has(img)::before,
	section div.split > div:has(picture)::before,
	section div.split > div:has(video)::before
	{
		content: '';
		position: absolute;
		top: -1px;
		left: 0;
		width: 100%;
		height: 41px;
		overflow: hidden;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M1200 120L0 16.48 0 0 1200 0 1200 120z' fill='%23faf9f6'%3E%3C/path%3E%3C/svg%3E");
		background-size: contain;
		background-position: bottom left;
	}

	section div.split > div:has(img)::after,
	section div.split > div:has(picture)::after,
	section div.split > div:has(video)::after
	{
		content: '';
		position: absolute;
		bottom: -1px;
		left: 0;
		width: 100%;
		height: 41px;
		overflow: hidden;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M1200 120L0 16.48 0 0 1200 0 1200 120z' fill='%23faf9f6'%3E%3C/path%3E%3C/svg%3E");
		background-size: contain;
		background-position: bottom left;
		transform: rotate(180deg);
	}

	section div.split > div:not(:has(img:only-child), :has(picture:only-child), :has(video:only-child))
	{
		text-align: center;
		padding: 4rem 0;
		order: 1;
	}

	section :deep(img),
	section :deep(picture),
	section :deep(video)
	{
		display: block;
		width: 100%;
		height: 50vh;
		max-width: none;
		object-fit: cover;
		box-shadow: none;
		border-radius: 0;
	}

	section :deep(h3)
	{
		padding: 0 1.5rem;
	}

	section div.split > div.left :deep(div),
	section div.split > div.right :deep(div)
	{
		margin: 0 auto;
		max-width: 1160px;
		padding: 0 1.2rem;
		box-sizing: border-box;
	}
}

@media screen and (max-width: 700px)
{
	section div.split > div:not(:has(img:only-child), :has(picture:only-child), :has(video:only-child))
	{
		padding: 1rem 0;
	}	
}
</style>